import { RootState } from '../types'

export const getSelectedMenu = (state: RootState) => state.menu.selected
